module.exports = __webpack_public_path__ + "img/shuixian.f510e6e1.png";